import { Spinner } from "./types";

export const SpinnerActions = {
    Open: (options = {}) => {
        return {
            type: Spinner.OPEN,
            options,
        };
    },
    Close: (options = {}) => {
        return {
            type: Spinner.CLOSE,
            options,
        };
    },
};
